/**
 * Utilitários para gerenciamento de cookies
 */

/**
 * Remove um cookie específico
 */
export const removeCookie = (name: string, path: string = '/', domain?: string): void => {
  // Remover com diferentes configurações para garantir que seja removido
  const options = [
    `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`,
    `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; domain=${domain || window.location.hostname}`,
    `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; domain=.${window.location.hostname}`,
    `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; secure`,
    `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; secure; samesite=strict`
  ];

  options.forEach(option => {
    document.cookie = option;
  });
};

/**
 * Remove todos os cookies da aplicação
 */
export const clearAllCookies = (): void => {
  const cookies = document.cookie.split(';');
  
  cookies.forEach(cookie => {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    
    if (name) {
      removeCookie(name);
    }
  });
};

/**
 * Remove cookies específicos de autenticação
 */
export const clearAuthCookies = (): void => {
  const authCookies = [
    'admin_token',
    'admin_refresh_token',
    'access_token',
    'refresh_token',
    'token',
    'auth_token'
  ];
  
  authCookies.forEach(cookieName => {
    removeCookie(cookieName);
  });
};

/**
 * Verifica se um cookie existe
 */
export const cookieExists = (name: string): boolean => {
  return document.cookie.split(';').some(cookie => 
    cookie.trim().startsWith(name + '=')
  );
};

/**
 * Obtém o valor de um cookie
 */
export const getCookie = (name: string): string | null => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=').map(c => c.trim());
    if (cookieName === name) {
      return cookieValue;
    }
  }
  return null;
};
